export type DeviceLogsProps = {
  deviceId: string;
}

export type Log = {
  id: string;
  data: string;
  deviceId: string;
  controlBlock: string;
  insertDateTime: string;
}

export const LIMITS = [50, 100, 500, 1000];
